import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'

export const useGetCalendarApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({productId, optionId, localDateStart, localDateEnd, units, currency}: Params.GetCalendar) => {
      const {data} = await ventrata.post<Ventrata.CalendarDay[]>(
        '/availability/calendar',
        {
          productId,
          optionId,
          units,
          localDateStart,
          localDateEnd,
          currency,
        },
        {
          headers: {
            'Octo-Capabilities': 'octo/pricing',
          },
        }
      )

      return data
    },
    [ventrata]
  )
}
